module.exports = __webpack_public_path__ + "img/mountain.ebb196bc.svg";